<app-tool-list
  [tableData]="tableData"
  [defaultSortOrder]="defaultSortOrder"
  [tableFilters]="filters"
  [searchParams]="searchParams"
  [toolModelExportParams]="toolModelExportParams"
  dataType="models"
  source="models"></app-tool-list>
